import { render, staticRenderFns } from "./yc-put-pond.vue?vue&type=template&id=66a127a6&"
import script from "./yc-put-pond.vue?vue&type=script&lang=js&"
export * from "./yc-put-pond.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports